import { render, staticRenderFns } from "./ModalCoInsurance.vue?vue&type=template&id=485e7a78"
import script from "./ModalCoInsurance.vue?vue&type=script&lang=js"
export * from "./ModalCoInsurance.vue?vue&type=script&lang=js"
import style0 from "./ModalCoInsurance.vue?vue&type=style&index=0&id=485e7a78&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports